import React, { useContext, useEffect } from 'react'
import { AppSettings } from '../../config/app-settings'
import { toast } from 'react-toastify'
import Loader from '../pages/loader'
import ReusableTable from '../../components/other/ReuseableTable'
import { useGetNewM3uLinksAggregateByCustomerQuery } from '../../redux/apis/linkManagement/m3u/lmNewM3uApiSlice'

const LiveStreamingReviewing = React.memo(() => {
  const context = useContext(AppSettings)
  const { data, isLoading, error } = useGetNewM3uLinksAggregateByCustomerQuery()

  let columns = [
    {
      title: 'Customer ID',
      dataIndex: 'customer_id',
      key: 'customer_id',

    },

    {
      title: 'CUSTOMERS',
      dataIndex: 'customers',
      key: 'customers',
      search: true,
      render: (customers, record) => <>{customers?.map(x => x)?.join(', ')}</>
    },

    {
      title: 'SCREENSHOTS COUNT',
      dataIndex: 'to_review_count',
      key: 'to_review_count',
      search: true
    },

    {
      title: 'Actions',
      dataIndex: 'customer_id',
      key: 'actions',
      render: (text, record) => (
        <div className='flex gap-2'>
          <a
            href={`/reviewing-screenshots/live-streaming/customer/${record?.customer_id}`}
            target='_blank'
            rel='noopener noreferrer'
            className='btn btn-outline-theme'
          >
            Review
          </a>
        </div>
      )
    }
  ]
  useEffect(() => {
    console.log(error)
    if (error) {
      toast.error(error)
    }
  }, [error])

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context]) // Add context as a dependency

  return (
    <div className='w-full flex flex-col'>
      <Loader isLoading={isLoading} />

      <div className='row'>
        <ReusableTable columns={columns} data={data?.data?.results} />
      </div>
    </div>
  )
})

export default LiveStreamingReviewing
